import React, { Component } from "react";
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import ModalMessage from '../../../shared/components/Modal';
import history from "../../../history";
import AudioPanel from '../../AudioPanel/AudioPanel';

class DaicomForm extends Component {

    constructor() {
        super();
        this.state = {
            history: '',
            description: '',
            tecnic: '',
            opinion: '',
            observation: '',
            note: '',
            openAlert: false,
            modalAlert: { message: '', color: '', title: '' },
        }
    }

    componentDidMount() {
        //console.log(this.props);
    }

    handlerHistory = (history) => {
        this.setState({ history: history });
    }

    handlerDescription = (description) => {
        this.setState({ description: description });
    }

    handlerTecnic = (tecnic) => {
        this.setState({ tecnic: tecnic });
    }

    handlerOpinion = (opinion) => {
        this.setState({ opinion: opinion });
    }

    handlerObservation = (observation) => {
        this.setState({ observation: observation });
    }

    handlerNote = (note) => {
        this.setState({ note: note });
    }

    saveHistory = () => {

        const dataSend = {
            antecedentes: this.state.history,
            tecnica: this.state.tecnic,
            descripcion: this.state.description,
            opinion: this.state.opinion,
            observacion: this.state.observation,
            nota: this.state.note,
            id_historia: this.props.id_historia,
            id_admision: this.props.id_admision
        };

        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-medicinanuclear/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                if (response.status === 200) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.setState({
                    openAlert: true,
                    modalAlert: {
                        message: "Guardado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    }
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    render() {
        const profile = sessionStorage.getItem('perfil');
        return (

            <>
                <form style={{ display: "flex", flexDirection: "column", border: '1px solid #6AA7F7', borderRadius: 10, marginTop: 20 }}>
                    <AudioPanel id_admision={this.props.id_admision} id_historia={this.props.id_historia} />
                </form>

                {/*
                <form className="material-form" style={{ display: "flex", flexDirection: "column", border: '1px solid #6AA7F7', borderRadius: 10, marginTop: 20 }}>
                    <div style={{ margin: 10 }}>

                        <h4> Registro </h4>
                        <TextField
                            className="material-form__field"
                            id="history-static"
                            label="Antecedentes"
                            onChange={(e) => {
                                this.handlerHistory(e.target.value);
                            }}
                        />
                        <TextField
                            className="material-form__field"
                            id="tecnic-static"
                            label="Tecnica"
                            onChange={(e) => {
                                this.handlerTecnic(e.target.value);
                            }}
                        />
                        <TextField
                            className="material-form__field"
                            id="description-static"
                            label="Descripcion"
                            onChange={(e) => {
                                this.handlerDescription(e.target.value);
                            }}
                        />
                        <TextField
                            className="material-form__field"
                            id="opinion-static"
                            label="Opinion"
                            onChange={(e) => {
                                this.handlerOpinion(e.target.value);
                            }}
                        />
                        <TextField
                            className="material-form__field"
                            id="observacion-static"
                            label="Observacion"
                            onChange={(e) => {
                                this.handlerObservation(e.target.value);
                            }}
                        />
                        <TextField
                            className="material-form__field"
                            id="note-static"
                            label="Nota"
                            onChange={(e) => {
                                this.handlerNote(e.target.value);
                            }}
                        />
                        {profile !== '16' ?
                            <Button
                                color="primary"
                                style={{ backgroundColor: 'black' }}
                                onClick={() => {
                                    this.saveHistory();
                                }}>
                                Guardar
                            </Button>
                            : null}
                    </div>
                    <ModalMessage
                        color={this.state.modalAlert.color}
                        title={this.state.modalAlert.title}
                        message={this.state.modalAlert.message}
                        modal={this.state.openAlert}
                        toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                        onOk={() => { this.setState({ openAlert: !this.state.openAlert }) }}

                    />
                </form>
                */}
            </>

        )
    }
}
export default reduxForm({
    form: `daicom-form`, // a unique identifier for this form
})(withTranslation('common')(DaicomForm));